import { defineFcm } from '../shared/factory';

export const FCM_STARFISH_HOMEPAGE_TO_SAP_DRAFT_V1 = defineFcm('starfish_homepage_to_sap_draft_v1')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-starfish',
		scope: 'corgi-front-end',
		context: 'starfish homepage to start a petition draft',
		description:
			'Controls display of the SAP input UI within the Starfish homepage hero section. Used by the starfish_homepage_to_sap_draft_v1 experiment.',
		import: false,
	});
